import { ComponentRef, Injectable } from '@angular/core';
import { Subject, tap, debounce, timer, distinctUntilChanged } from 'rxjs';
import { TreeListActionsComponent } from '../components/utils/tree-list/tree-list-actions/tree-list-actions.component';

@Injectable()
export class TreeListUtilsService {
  private _rowHoverChanged$ = new Subject<ComponentRef<TreeListActionsComponent>>();
  private _lastRef: ComponentRef<TreeListActionsComponent>;

  public sendRowHoverPayload(ref: ComponentRef<TreeListActionsComponent>) {
    if (ref && this._lastRef && this._lastRef !== ref) {
      this.hideActionBar(this._lastRef);
    }
    if (ref) this._lastRef = ref;
    this._rowHoverChanged$.next(ref);
  }

  public getRowHoverEvents() {
    return this._rowHoverChanged$.pipe(
      distinctUntilChanged(),
      debounce((ref) => timer(!!ref ? 500 : 0)),
      tap((ref) => {
        if (!ref) {
          this.hideActionBar(this._lastRef);
        } else {
          this.showActionBar(ref);
        }
      }),
    );
  }

  public hideActionBar(ref: ComponentRef<TreeListActionsComponent>) {
    if (!ref || ref.instance.hidden()) {
      return;
    }
    ref.setInput('hidden', true);
  }

  public hideLastActionOnTreeLeave() {
    this._rowHoverChanged$.next(null);
  }

  public showActionBar(ref: ComponentRef<TreeListActionsComponent>) {
    if (!ref) {
      return;
    }
    ref.setInput('hidden', false);
  }
}
